
























































































import { Component } from 'vue-property-decorator';

import DclAdd from '@/components/DraggableCardList/DclAdd.vue';
import DclCard from '@/components/DraggableCardList/DclCard.vue';
import DclGrid from '@/components/DraggableCardList/DclGrid.vue';
import HoursSection from './HoursSection';

@Component({
	components: {
		DclAdd,
		DclCard,
		DclGrid,
	}
})
export default class HoursDriveThrough extends HoursSection {
	hoursType = 'driveThroughHours';

	get driveThroughSameAsLobby(): boolean {
		return this.location.driveThroughSameAsLobby;
	}

	set driveThroughSameAsLobby(value: boolean) {
		this.location.driveThroughSameAsLobby = value;
		if (value) {
			// referenced arrays will not be used on pageload;
			// to keep data in sync, do it in the lobby hours section
			this.location.driveThroughHours = this.dereference(this.location.lobbyHours);
		}
	}
}

